import {
  SecuritySettingsDomainSectionFragment,
  SecuritySettingsSecuritySettingsPageFragment,
} from 'generated/resources/graphql'
import { CompanyConfigDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type TypedSecuritySettingsSecuritySettingsPageFragment =
  SecuritySettingsSecuritySettingsPageFragment

export type TypedSecuritySettingsSecurityDomainFragment = SecuritySettingsDomainSectionFragment

export function useCompanyConfig(companyId: number) {
  const { loading, data, error } = useQuery(CompanyConfigDocument, { variables: { companyId } })

  const companyConfig = data ? data.securitySettings.companyConfigsConnection.nodes[0] : undefined

  const canUpdateCompanyConfig = !!data?.securitySettings._policies.updateCompanyConfig.can

  const domainConfig = data ? data.authentication.domainsConnection.nodes : undefined

  return {
    canUpdateCompanyConfig,
    loading,
    error,
    companyConfig,
    domainConfig,
  }
}
